/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9d0464203d8c1f588f67b60304efd94>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "QrCode".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for QR code experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const QrCodeIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="M10 10h2v2h-2z"/><path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v2.25H1V3a2 2 0 0 1 2-2h2.25v1.5zM10.75 1H13a2 2 0 0 1 2 2v2.25h-1.5V3a.5.5 0 0 0-.5-.5h-2.25zM4 4h5v5H4zm1.5 1.5v2h2v-2zm5 2.5V4H12v4zM8 12H4v-1.5h4zm-7 1v-2.25h1.5V13a.5.5 0 0 0 .5.5h2.25V15H3a2 2 0 0 1-2-2m12.5 0v-2.25H15V13a2 2 0 0 1-2 2h-2.25v-1.5H13a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
QrCodeIcon.displayName = 'QrCodeIcon';
var _default = exports.default = QrCodeIcon;